module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Music-bd4fe5ac07feb51a94292fb9f62c761f.svg";